import {Component} from "preact";
import Session from "../../utils/session";
import Admin from "../../../../services/admin";
import MoneyFormatter from "../../utils/money-formatter";
import {Cell, CustomTable, FiltersRow, HCell, HRow, Panel, PanelRow, Row, SelectFilter} from "../../utils/table-utils";
import { Trans } from "@lingui/react/macro";
import {LazyTree} from "../../utils/suggest-tree-filter";
import {DateHelperFilter} from "../../utils/form-utils";


export default class ManagerReport extends Component {
    state = {
        dateFilter: {
            helperValue: 0,
            dateStartValue: null,
            dateEndValue: null
        },
        structures: {
            filterid: 0,
            children: null,
            collapseFilter: false
        },
        usetree: true,
        service: '6', //> Default: betting
        response: {}
    };

    componentWillMount() {
        if (this.props.usetree === true || this.props.usetree === false) {
            this.state.usetree = this.props.usetreee;
        }
        this.state.dateFilter.helperValue = 1; // Oggi
        this.state.dateFilter.dateStartValue = new Date().toLocaleDateString('en-CA');
        this.state.dateFilter.dateEndValue = this.state.dateFilter.dateStartValue;
        this.state.structures.children = [{id: Session.fetch('id'), name: Session.fetch('username')}];
        this.performSearch();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.usetree === true || nextProps.usetree === false) {
            this.state.usetree = nextProps.usetreee;
        }
    }

    getManagerChildren(id, cb) {
        Admin.managerChildren(id)
            .catch(e => cb(e, []))
            .then(data => cb(null, {data: data.filter(item => item.type !== 'player')}));
    }

    filterFromManagerChildren(structure) {
        if (structure.type === 'player') {
            /* Non è prevista una ricerca per players */
        } else {
            this.state.structures.filterid = structure.id;
            Admin.setOperatorId(this.state.structures.filterid);
        }

        this.setState(this.state);
        this.performSearch();
    }

    performSearch() {
        Admin.managerReport({
            searchHelper: this.state.dateFilter.helperValue,
            searchStartDate: this.state.dateFilter.dateStartValue,
            searchEndDate: this.state.dateFilter.dateEndValue
        }).then(response => this.setState({response: !!response.data? response.data : {}}));
    }

    moneyFormatter(moneyobject) {
        const output = [];

        Object.entries(moneyobject)
            .map(([currency,amount]) => output.push(<MoneyFormatter currency={currency} value={amount} />));

        return output;
    }

    generalReportRender() {
        const totalProfit = this.state.response['general-report']
        return <Panel>
            <PanelRow>
                {!this.state.response['general-report']?
                    <div class="text-center text-lg text-gray-500">
                        <Trans>Non ci sono record da mostrare</Trans>
                    </div>
                    : <CustomTable style="font-family:'Arial rounded', Arial, sans-serif;">
                        <thead>
                        <HRow class="text-center">
                            <HCell class="font-bold bg-gray-200" first={true}><strong class="block text-left body-bg-color"><Trans>Tipo Tickets</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Num. Tickets</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Num. In Corso</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Num. Vincenti</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Num. Rifiutati</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Tot. Rifiutato</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Tot. Scommesso</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Tot. In Corso</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Tot. Vinto</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Media Bet/Ticket</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Rating Vincite</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Utile Lordo</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Utile Netto</Trans></strong></HCell>
                        </HRow>
                        </thead>
                        <tbody class="text-center">
                        {!!this.state.response['prematchtickets-report'] && <Row class="hover:bg-gray-200 border-b">
                            <Cell first={true} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-left font-bold"><Trans>Prematch</Trans></span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['prematchtickets-report'].ticketcount}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].progresscount.prematch}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].winnerscount.prematch}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['prematchtickets-report'].rejectedcount}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right">{this.moneyFormatter(this.state.response['prematchtickets-report'].rejected)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-green-600">{this.moneyFormatter(this.state.response['prematchtickets-report'].tot_bets)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-green-600 opacity-60">{this.moneyFormatter(this.state.response['prematchtickets-report'].tot_progress)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-red-600">{this.moneyFormatter(this.state.response['prematchtickets-report'].tot_wins)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right">{this.moneyFormatter(this.state.response['prematchtickets-report'].tot_betsavg)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['prematchtickets-report'].tot_winsrating}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-right '+ (parseFloat(Object.values(this.state.response['prematchtickets-report'].tot_grossprofit)[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(this.state.response['prematchtickets-report'].tot_grossprofit)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-right '+ (parseFloat(Object.values(this.state.response['prematchtickets-report'].tot_profit)[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(this.state.response['prematchtickets-report'].tot_profit)}</span>
                            </Cell>
                        </Row>}
                        {!!this.state.response['livetickets-report'] && <Row class="hover:bg-gray-200 border-b">
                            <Cell first={true} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-left font-bold"><Trans>Live</Trans></span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['livetickets-report'].ticketcount}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].progresscount.live}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].winnerscount.live}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['livetickets-report'].rejectedcount}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right">{this.moneyFormatter(this.state.response['livetickets-report'].tot_rejected)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-green-600">{this.moneyFormatter(this.state.response['livetickets-report'].tot_bets)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-green-600 opacity-60">{this.moneyFormatter(this.state.response['livetickets-report'].tot_progress)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-red-600">{this.moneyFormatter(this.state.response['livetickets-report'].tot_wins)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right">{this.moneyFormatter(this.state.response['livetickets-report'].tot_betsavg)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['livetickets-report'].tot_winsrating}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-right '+ (parseFloat(Object.values(this.state.response['livetickets-report'].tot_grossprofit)[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(this.state.response['livetickets-report'].tot_grossprofit)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-right '+ (parseFloat(Object.values(this.state.response['livetickets-report'].tot_profit)[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(this.state.response['livetickets-report'].tot_profit)}</span>
                            </Cell>
                        </Row>}
                        {!!this.state.response['mixedtickets-report'] && <Row class="hover:bg-gray-200 border-b">
                            <Cell first={true} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-left font-bold"><Trans>Live/Prematch</Trans></span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['mixedtickets-report'].ticketcount}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].progresscount.mixed}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].winnerscount.mixed}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['mixedtickets-report'].rejectedcount}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right">{this.moneyFormatter(this.state.response['mixedtickets-report'].rejected)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-green-600">{this.moneyFormatter(this.state.response['mixedtickets-report'].tot_bets)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-green-600 opacity-60">{this.moneyFormatter(this.state.response['mixedtickets-report'].tot_progress)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-red-600">{this.moneyFormatter(this.state.response['mixedtickets-report'].tot_wins)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right">{this.moneyFormatter(this.state.response['mixedtickets-report'].tot_betsavg)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['mixedtickets-report'].tot_winsrating}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-right '+ (parseFloat(Object.values(this.state.response['mixedtickets-report'].tot_grossprofit)[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(this.state.response['mixedtickets-report'].tot_grossprofit)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-right '+ (parseFloat(Object.values(this.state.response['mixedtickets-report'].tot_profit)[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(this.state.response['mixedtickets-report'].tot_profit)}</span>
                            </Cell>
                        </Row>}
                        <Row class="hover:bg-gray-200 border-b">
                            <Cell first={true} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-left font-bold"><Trans>Sistema</Trans></span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['systemtickets-report'].ticketcount}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].progresscount.system}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].winnerscount.system}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['systemtickets-report'].rejectedcount}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right">{this.moneyFormatter(this.state.response['systemtickets-report'].rejected)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-green-600">{this.moneyFormatter(this.state.response['systemtickets-report'].tot_bets)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-green-600 opacity-60">{this.moneyFormatter(this.state.response['systemtickets-report'].tot_progress)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-red-600">{this.moneyFormatter(this.state.response['systemtickets-report'].tot_wins)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right">{this.moneyFormatter(this.state.response['systemtickets-report'].tot_betsavg)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['systemtickets-report'].tot_winsrating}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-right '+ (parseFloat(Object.values(this.state.response['systemtickets-report'].tot_grossprofit)[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(this.state.response['systemtickets-report'].tot_grossprofit)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-right '+ (parseFloat(Object.values(this.state.response['systemtickets-report'].tot_profit)[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(this.state.response['systemtickets-report'].tot_profit)}</span>
                            </Cell>
                        </Row>
                        <Row class="hover:bg-gray-200 border-b border-t-4">
                            <Cell first={true} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-left font-bold"><Trans>Totale</Trans></span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].ticketscount.total}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].progresscount.total}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].winnerscount.total}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].rejectedcount.total}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right">{this.moneyFormatter(this.state.response['general-report'].tot_rejected)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-green-600">{this.moneyFormatter(this.state.response['general-report'].tot_bets)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-green-600 opacity-60">{this.moneyFormatter(this.state.response['general-report'].tot_progress)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right text-red-600">{this.moneyFormatter(this.state.response['general-report'].tot_wins)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-right">{this.moneyFormatter(this.state.response['general-report'].tot_betsavg)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center">{this.state.response['general-report'].tot_winsrating}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-right '+ (parseFloat(Object.values(this.state.response['general-report'].tot_grossprofit)[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(this.state.response['general-report'].tot_grossprofit)}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-right '+ (parseFloat(Object.values(this.state.response['general-report'].tot_profit)[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(this.state.response['general-report'].tot_profit)}</span>
                            </Cell>
                        </Row>
                        </tbody>
                    </CustomTable>}
            </PanelRow>
        </Panel>;
    }

    serviceReportRender() {
        const report = !!this.state.response['services-report']?
            this.state.response['services-report'].filter(item => item.service.id === parseInt(this.state.service))
            : [];
        const service = !!report.length? report.pop() : null;

        return <Panel>
            <PanelRow>
                {!service?
                    <div class="text-center text-lg text-gray-500">
                        <Trans>Non ci sono record da mostrare</Trans>
                    </div>
                    : <CustomTable class="m-auto w-full" style="font-family:'Arial rounded', Arial, sans-serif;">
                        <thead>
                        <HRow class="text-center">
                            <HCell class="font-bold bg-gray-200" first={true}><strong class="block text-left body-bg-color"><Trans>Servizio</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>In</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Out</Trans></strong></HCell>
                            <HCell class="font-bold bg-gray-200" first={false}><strong class="block text-center body-bg-color"><Trans>Utile</Trans></strong></HCell>
                        </HRow>
                        </thead>
                        <tbody class="text-center">
                        <Row class="hover:bg-gray-200 border-b border-t-4">
                            <Cell first={true} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-left font-bold">{service.service.name}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center text-green-600">{this.moneyFormatter(service['tot_in'])}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class="block px-2 text-center text-red-600">{this.moneyFormatter(service['tot_out'])}</span>
                            </Cell>
                            <Cell first={false} class="leading-7" borderColor="var(--main-color)">
                                <span class={'block px-2 text-center '+ (parseFloat(Object.values(service['tot_in/out'])[0])<0? 'text-red-600' : 'text-green-600')}>{this.moneyFormatter(service['tot_in/out'])}</span>
                            </Cell>
                        </Row>
                        </tbody>
                    </CustomTable>}
            </PanelRow>
        </Panel>;
    }

    render() {
        return <div class="flex flex-row">
            {!!this.state.usetree && !!this.state.structures.children && <div class="flex-shrink-0 p-2 text-xs">
                <div class="bg-white border h-full p-3 relative">
                    <a
                        class="absolute p-1 rounded-r border border-l-0 bg-white text-gray-500 left-full top-[40px]"
                        onClick={e => {
                            this.state.structures.collapseFilter = !this.state.structures.collapseFilter;
                            this.setState(!this.state);
                        }}
                        href="javascript:void(0);"
                    >
                        {this.state.structures.collapseFilter?
                            <i class="fa fa-caret-right" />
                            : <i class="fa fa-caret-left" />}
                    </a>
                    <div
                        class={"border-l-4 border-l-[#38b2ac] border flex-0 max-h-screen overflow-auto overflow-x-hidden bg-white min-h-full"+(this.state.structures.collapseFilter? ' w-px' : ' w-56')}
                    >
                        <LazyTree
                            data={this.state.structures.children}
                            loadChildren={(id, cb) => this.getManagerChildren(id, cb)}
                            onNodeSelected={structure => this.filterFromManagerChildren(structure)}
                            currentSelection={this.state.structures.filterid}
                            firstLevelOpen={true}
                        />
                    </div>
                </div>
            </div>}
            <div class="w-full">
                <div class="px-3">
                    <FiltersRow class="p-2 text-sm items-end justify-center">
                        <label class="mx-px">
                            <span class="block text-xs"><Trans>Servizio</Trans></span>
                            <SelectFilter class="bg-white py-2" onChange={e => this.setState({service: e.currentTarget.value})}>
                                <option value="6" selected={this.state.service === '6'}><Trans>Betting</Trans></option>
                                {!!this.state.response['services-report'] && this.state.response['services-report'].map(
                                    item => <option value={item.service.id}>{item.service.name}</option>
                                )}
                            </SelectFilter>
                        </label>
                        <DateHelperFilter
                            {...this.state.dateFilter}
                            onInput={
                                (dateFilter) => {
                                    this.state.dateFilter = dateFilter;
                                    this.setState(this.state);
                                }
                            }
                        />
                        <a href="javascript:void(0);" class="button p-2 ml-5 main-text-color" onClick={e => this.performSearch()}>
                            <Trans>Avvia Ricerca <i class="fa fa-search" /></Trans>
                        </a>
                    </FiltersRow>
                    <div class="text-xs mt-3">
                        {this.state.service === '6'? this.generalReportRender() : this.serviceReportRender()}
                    </div>
                </div>
            </div>
        </div>;
    }
}